export enum LegalDocumentType {
  HTML = 'html',
  PDF = 'pdf',
}
